export default "__VITE_ASSET__Cs9N3TS7__"